import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=76b8429a&scoped=true"
import script from "./logout.vue?vue&type=script&lang=js"
export * from "./logout.vue?vue&type=script&lang=js"
import style0 from "./logout.vue?vue&type=style&index=0&id=76b8429a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8429a",
  null
  
)

export default component.exports